import { createFileRoute } from '@tanstack/react-router'
import { DatenschutzPage } from '~/features/landing/LegalPage'

export const Route = createFileRoute('/datenschutz')({
  component: DatenschutzPage,
})
